import { getLocalTranslation } from '../../utils/i18nKit';
export var getQuoteRecruitmentBusinessTypeMap = function getQuoteRecruitmentBusinessTypeMap(shortText) {
  var _getLocalTranslation = getLocalTranslation(),
      $t = _getLocalTranslation.$t;

  return {
    recruitmentAgency: {
      value: 'recruitment_agency',
      label: !!shortText ? 'Recruitment' : $t('kit:recruitmentTextInfo.recruitment_agency')
    },
    umbrellaPayrollBusiness: {
      value: 'umbrella_payroll_business',
      label: !!shortText ? 'Payroll' : $t('kit:recruitmentTextInfo.umbrella_payroll_business')
    },
    recruitmentAgencyIncludingUmbrellaPayrollActivities: {
      value: 'recruitment_agency_including_umbrella_activities',
      label: !!shortText ? 'Recruitment including payroll' : $t('kit:recruitmentTextInfo.recruitment_agency_including_umbrella_payroll_activities')
    }
  };
};
export var getQuoteRecruitmentBusinessTypeList = function getQuoteRecruitmentBusinessTypeList(shortText) {
  return Object.values(getQuoteRecruitmentBusinessTypeMap(shortText));
};
export var getQuoteRecruitmentSplitRecruitmentAndPayrollPercentMap = function getQuoteRecruitmentSplitRecruitmentAndPayrollPercentMap() {
  var _getLocalTranslation2 = getLocalTranslation(),
      $t = _getLocalTranslation2.$t;

  return {
    recruitment: {
      value: 'recruitment',
      label: $t('kit:recruitmentTextInfo.recruitment')
    },
    payroll: {
      value: 'payroll',
      label: $t('kit:recruitmentTextInfo.payroll')
    }
  };
};
export var getQuoteRecruitmentSplitRecruitmentAndPayrollPercentList = function getQuoteRecruitmentSplitRecruitmentAndPayrollPercentList() {
  return Object.values(getQuoteRecruitmentSplitRecruitmentAndPayrollPercentMap());
};
export var getQuoteRecruitmentSplitPlacedCandidatesPermanentAndTemporaryPercentMap = function getQuoteRecruitmentSplitPlacedCandidatesPermanentAndTemporaryPercentMap() {
  var _getLocalTranslation3 = getLocalTranslation(),
      $t = _getLocalTranslation3.$t;

  return {
    permanent: {
      value: 'placed_candidates_permanent',
      label: $t('kit:recruitmentTextInfo.placed_candidates_permanent')
    },
    temporary: {
      value: 'placed_candidates_temporary',
      label: $t('kit:recruitmentTextInfo.placed_candidates_temporary')
    }
  };
};
export var getQuoteRecruitmentSplitPlacedCandidatesPermanentAndTemporaryPercentList = function getQuoteRecruitmentSplitPlacedCandidatesPermanentAndTemporaryPercentList() {
  return Object.values(getQuoteRecruitmentSplitPlacedCandidatesPermanentAndTemporaryPercentMap());
};